import { notification, closeNotification } from '../../../components/Notifications'
import { exportCsv } from '../../../utils/exportCsv'

type SetTaskFn = (taskId: string, message: string, successMessage?: string, onComplete?: () => void) => void

interface CourseExportSuccessDeps {
  setTask: SetTaskFn
}

const DEFAULT_EXPORT_STARTED_DESCRIPTION = "Your file is being prepared. You'll be notified when it's ready."

const getExportStartedDescription = (message: unknown): string => {
  return typeof message === 'string' && message.trim() ? message : DEFAULT_EXPORT_STARTED_DESCRIPTION
}

const getTaskMessage = (message: unknown): string => {
  return typeof message === 'string' && message.trim() ? message : 'Your export is running in the background.'
}

export const createCourseExportSuccessHandler = ({ setTask }: CourseExportSuccessDeps) =>
  (response: any, _variables: any, context: any): void => {
    if (response?.status === 202) {
      const { taskId, message } = response.data ?? {}
      if (taskId) {
        const taskMsg = getTaskMessage(message)
        setTask(taskId, taskMsg, 'Your export is ready.')
        notification('Export started', { variant: 'info', subTitle: getExportStartedDescription(message) })
      }
      closeNotification(context)
      return
    }

    const data = response?.data
    if (data) {
      exportCsv({ data, headers: response?.headers, loadingToastKey: context })
    } else {
      closeNotification(context)
    }
  }
